// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { fg } from '@atlassian/jira-feature-gating';
import { KEY_TASK_GROUP, ROOT_TASK } from '../../../common/constants.tsx';
import { pushToBackend } from '../../../common/utils/push-to-backend.tsx';
import type { State } from '../../model/types.tsx';

type TaskGroup = {
	previousTaskGroupParents: string[];
	currentTaskGroupParent: string;
};

const setTaskGroup =
	(taskGroup: TaskGroup, openTask?: string): Action<State> =>
	({ setState }) => {
		setState({ ...taskGroup, openTask: openTask || '' });

		pushToBackend({
			key: KEY_TASK_GROUP,
			value: {
				taskGroup,
			},
		});
	};

export const nextChangeTaskGroupParent =
	(newCurrentTaskGroupParent: string): Action<State> =>
	({ getState, dispatch }) => {
		const { previousTaskGroupParents, currentTaskGroupParent } = getState();

		if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) {
			// prevent infinite loop nesting
			return;
		}

		previousTaskGroupParents.push(currentTaskGroupParent);

		const taskGroup = {
			previousTaskGroupParents,
			currentTaskGroupParent: newCurrentTaskGroupParent,
		};
		dispatch(setTaskGroup(taskGroup));
	};

export const nextGoBackToPreviousTaskGroup =
	(): Action<State> =>
	({ dispatch, getState }) => {
		if (fg('jira_a11y_fix_returning_focus')) {
			const { previousTaskGroupParents, currentTriggerForTaskGroupParent } = getState();
			const lastIndexOfPreviousTaskGroupParents = previousTaskGroupParents.length - 1;

			const newTaskGroupParent =
				previousTaskGroupParents.length === 0
					? ROOT_TASK
					: previousTaskGroupParents[lastIndexOfPreviousTaskGroupParents];

			const newPreviousTaskGroupParents = previousTaskGroupParents.slice(
				0,
				lastIndexOfPreviousTaskGroupParents,
			);

			const taskGroup = {
				previousTaskGroupParents: newPreviousTaskGroupParents,
				currentTaskGroupParent: newTaskGroupParent,
			};

			dispatch(setTaskGroup(taskGroup, currentTriggerForTaskGroupParent));
		} else {
			const { previousTaskGroupParents } = getState();

			const newTaskGroupParent =
				previousTaskGroupParents.length === 0 ? ROOT_TASK : previousTaskGroupParents.pop();

			const taskGroup = { previousTaskGroupParents, currentTaskGroupParent: newTaskGroupParent };
			// @ts-expect-error - TS2345 - Argument of type '{ previousTaskGroupParents: string[]; currentTaskGroupParent: string | undefined; }' is not assignable to parameter of type 'TaskGroup'.
			dispatch(setTaskGroup(taskGroup));
		}
	};
